import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = {
  lat: 13.736717,
  lng: 100.523186,
  isDefault: true,
}
const locationSlice = createSlice({
    name:'location',
    initialState,
    reducers:{
        updateLocation:(state, action: PayloadAction<any>)=>{
            console.log('action',action);
            return action.payload || null
        }
    }
})

export const { updateLocation } = locationSlice.actions
export default locationSlice.reducer